import { Provider } from '@angular/core';

import { RouterService } from '../router.service';
import { UIStateService } from '../ui-state.service';
import { StateMachineService } from '../state-machine.service';
import { ValidationService } from '../validation.service';
import { BindingDataService } from '../binding-data.service';
import { CommandService } from '../command-service';

import { NavigationEventService } from '../navigation-event.service';
import { NavigationService } from '../navigation.service';
import { NavigationMiddlewareService } from '../navigation-middleware.service';
import { GridMiddlewareService } from '../grid.middleware.service';

import { BeActionService } from '../be-action.service';
import { ApproveService } from '../approve.service';
import { PrintService } from '../print.service';
import { AttachmentDataService, AttachmentService, FileService } from '../attachment/index';
import {
    EntityTraversingService, EntityManipulationService, EntityAggregationService,
    EntityListService, EntityService
} from '../entity-services/index';
import { DialogService } from '../dialog.service';
import { SidebarService } from '../sidebar-service';
import { FarrisFormService } from '../farris-form.service';
import { ChangeItemService } from '../change-item.service';

// data-services
import { ListDataService } from '../data-services/list-data.service';
import { TreeDataService } from '../data-services/tree-data.service';
import { CardDataService } from '../data-services/card-data.service';
import { SubListDataService } from '../data-services/sub-list-data.service';
import { FocusInvalidService } from '../focus-invalid.service';
import { SubTreeDataService } from '../data-services/sub-tree-data-service';
import { RemoveDataService } from '../data-services/remove-data.service';
import { SaveDataService } from '../data-services/save-data.service';
import { EditDataService } from '../data-services/edit-data.service';
import { FilterConditionDataService } from '../data-services/filter-condition-data.service';
import { RemoteSummaryService } from '../remote-summary.service';
import { AuthorityService } from '../authority/authority.service';
import { EndEditService } from '../end-edit.service';
import { BatchEditService } from '../batch-edit.service';
import { DiscussionGroupService } from '../discussion-group.service';
import { LocalizationService } from '../localization.service';
import { DataGridService } from '../data-grid.service';
import { FormAttentionService } from '../form-attention.service';
import { FormManifestService } from '../manifest/form_manifest_service';
import { FormExpressionManifestService } from '../manifest/form_expression_manifest_service';
import { ListFilterConditionsService } from '../list-filter/list-filter.service';
import { QuerySolutionService } from '../query-solution/query-solution.service';
import { BatchEditDialogService } from '@farris/ui-batch-edit-dialog';
import { FORM_MANIFEST_SERVICE_TOKEN, FORM_EXPRESSION_MANIFEST_SERVICE_TOKEN } from '@farris/devkit';
import { QUERYSOLUTION_HANDLER_TOKEN } from '@gsp-cmp/querysolution';
import { LISTFILTER_HANDLER_TOKEN } from '@farris/ui-list-filter';

/**
 * ç»ä»¶çº§æ³¨å¥æ³¨å¥(å±23ä¸ª)
 */
const DYNAMIC_FARRIS_COMMAND_SERVICE_PROVIDERS: Provider[] = [
    { provide: 'ValidationService', useClass: ValidationService },
    { provide: 'FocusInvalidService', useClass: FocusInvalidService },
    { provide: 'ChangeItemService', useClass: ChangeItemService },
    { provide: 'UIStateService', useClass: UIStateService },
    { provide: 'StateMachineService', useClass: StateMachineService },
    { provide: 'BindingDataService', useClass: BindingDataService },
    { provide: 'CommandService', useClass: CommandService },

    // entity-services
    { provide: 'EntityTraversingService', useClass: EntityTraversingService },
    { provide: 'EntityManipulationService', useClass: EntityManipulationService },
    { provide: 'EntityAggregationService', useClass: EntityAggregationService },
    { provide: 'EntityListService', useClass: EntityListService },
    { provide: 'EntityService', useClass: EntityService },

    // data-services
    { provide: 'ListDataService', useClass: ListDataService },
    { provide: 'TreeDataService', useClass: TreeDataService },
    { provide: 'SubTreeDataService', useClass: SubTreeDataService },
    { provide: 'CardDataService', useClass: CardDataService },
    { provide: 'SubListDataService', useClass: SubListDataService },
    { provide: 'RemoveDataService', useClass: RemoveDataService },
    { provide: 'SaveDataService', useClass: SaveDataService },
    { provide: 'EditDataService', useClass: EditDataService },
    { provide: 'FilterConditionDataService', useClass: FilterConditionDataService },
    { provide: 'RemoteSummaryService', useClass: RemoteSummaryService },

    { provide: 'BeActionService', useClass: BeActionService },
    { provide: 'ApproveService', useClass: ApproveService },
    { provide: 'PrintService', useClass: PrintService },
    { provide: 'AttachmentDataService', useClass: AttachmentDataService },
    { provide: 'AttachmentService', useClass: AttachmentService },
    { provide: 'FileService', useClass: FileService },
    { provide: 'NavigationMiddlewareService', useClass: NavigationMiddlewareService },
    { provide: 'GridMiddlewareService', useClass: GridMiddlewareService },
    { provide: 'SidebarService', useClass: SidebarService },
    { provide: 'FarrisFormService', useClass: FarrisFormService },
    { provide: 'DialogService', useClass: DialogService },
    { provide: 'NavigationEventService', useClass: NavigationEventService },
    { provide: 'NavigationService', useClass: NavigationService },
    { provide: 'RouterService', useClass: RouterService },
    { provide: 'AuthorityService', useClass: AuthorityService },
    {
        provide: QUERYSOLUTION_HANDLER_TOKEN,
        useClass: QuerySolutionService
    },
    {
        provide: LISTFILTER_HANDLER_TOKEN,
        useClass: ListFilterConditionsService
    },
    { provide: 'EndEditService', useClass: EndEditService },
    { provide: 'BatchEditDialogService', useClass: BatchEditDialogService },
    { provide: 'BatchEditService', useClass: BatchEditService },
    { provide: 'DiscussionGroupService', useClass: DiscussionGroupService },
    { provide: 'LocalizationService', useClass: LocalizationService },
    { provide: 'DataGridService', useClass: DataGridService },
    { provide: 'FormAttentionService', useClass: FormAttentionService },
    // è¡¨è¾¾å¼
    { provide: FORM_MANIFEST_SERVICE_TOKEN, useClass: FormManifestService },
    { provide: FORM_EXPRESSION_MANIFEST_SERVICE_TOKEN, useClass: FormExpressionManifestService }
];


export { DYNAMIC_FARRIS_COMMAND_SERVICE_PROVIDERS };
